import type { SvelteComponentDev } from "svelte/internal";
import { writable } from "svelte/store";


type PopupType = {
    component: typeof SvelteComponentDev,
    props?: any
}

export const popup = writable<PopupType | undefined>();

